<app-create-stage-form [stages]="stages$ | async" (goBackOnRouter$)="navigateToPreviousPage($event)"
    (createStage$)="onCreateStage($event)"></app-create-stage-form>